module.exports = __webpack_public_path__ + "way2go/static/config/info_icon.svg";